// Shared helpers for US phone number inputs across the reservation portals.
//
// US (NANP) numbers are 10 digits and the area code can never start with
// 0 or 1, so we drop any leading 0/1 (this also strips a "1" country code
// when a full number is pasted) and keep at most 10 digits.

const MAX_US_DIGITS = 10;

// Keep only digits, remove any leading 0/1, and cap at 10 digits.
export const extractUSDigits = (value) => {
	if (!value) return "";

	let digits = value.replace(/\D/g, "");

	while (digits.length && (digits[0] === "0" || digits[0] === "1")) {
		digits = digits.slice(1);
	}

	return digits.slice(0, MAX_US_DIGITS);
};

// Format a value as a US phone number: (XXX) XXX-XXXX.
export const formatPhoneNumber = (value) => {
	const extractNumber = extractUSDigits(value);
	if (!extractNumber) return null;

	const first3String = extractNumber.substring(0, 3);
	const second3String = extractNumber.substring(3, 6);
	const remString = extractNumber.substring(6, 10);

	return `${first3String ? `(${first3String})` : ""}${second3String ? ` ${second3String}` : ""}${remString ? `-${remString}` : ""}`;
};

// A complete, valid US phone number has exactly 10 digits after sanitizing.
export const isValidUSPhoneNumber = (value) => extractUSDigits(value).length === MAX_US_DIGITS;
